import { create } from "zustand";

const useProcessingStore = create((set) => ({
	isProcessing: false,
	message: "",

	startProcessing: (message = "Procesando...") =>
		set({
			isProcessing: true,
			message,
		}),

	stopProcessing: () =>
		set({
			isProcessing: false,
			message: "",
		}),
}));

export default useProcessingStore;
